const validationType = {
  mail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  postalCode: /^[0-9]{5}$/,
  streetCity: /^[A-Za-zÀ-ž\s-.]{3,}$/,
  houseNumber: /^[0-9]{1,}[A-Za-z]{0,1}$/,
  date: (dateString) => {
    const dateParts = dateString.split(".");
    const date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return (
      // eslint-disable-next-line no-restricted-globals
      !isNaN(date.getDay()) &&
      date.getFullYear() === parseInt(dateParts[2], 10) &&
      date.getMonth() === parseInt(dateParts[1], 10) - 1 &&
      date.getDate() === parseInt(dateParts[0], 10)
    );
  },
};

function validate(validation, testedValue) {
  if (typeof validation === "function") {
    return validation(testedValue);
  }

  const regEx = new RegExp(validation);
  return regEx.test(testedValue);
}

export { validate, validationType };
